import type { ApiQuote } from '../../types/api';

type QuoteListener = (quote: ApiQuote) => void;

const listeners = new Map<string, Set<QuoteListener>>();
const latestQuotes = new Map<string, ApiQuote>();

export function publishQuoteUpdates(quotes: ApiQuote[]): void {
  for (const quote of quotes) {
    const symbol = normalizeSymbol(quote.symbol);
    latestQuotes.set(symbol, quote);
    const symbolListeners = listeners.get(symbol);
    if (!symbolListeners) continue;
    for (const listener of symbolListeners) listener(quote);
  }
}

export function subscribeQuoteUpdates(symbol: string, listener: QuoteListener): () => void {
  const key = normalizeSymbol(symbol);
  let symbolListeners = listeners.get(key);
  if (!symbolListeners) {
    symbolListeners = new Set();
    listeners.set(key, symbolListeners);
  }
  symbolListeners.add(listener);
  const latestQuote = latestQuotes.get(key);
  if (latestQuote) queueMicrotask(() => listener(latestQuote));
  return () => {
    symbolListeners?.delete(listener);
    if (symbolListeners?.size === 0) listeners.delete(key);
  };
}

function normalizeSymbol(symbol: string): string {
  return symbol.trim().toUpperCase();
}
